<mat-card class="generate-tmk-dialog" >
  <!-- Header -->
  <mat-card-header class="header-container">
    <mat-card-title>Update TMK</mat-card-title>
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <!-- Content -->
    <mat-card-content class="padding lrg all">
      <div class="row mecs" *ngIf="formError">
        <div class="errors">
          <div class="icon-circle">
            <mat-icon class="errors-icon">close</mat-icon>
          </div>
          <h6 class="margin left">
            {{ formError }}
          </h6>
        </div>
      </div>

      <!-- Parity -->
      <app-kba-input-array
        (inputUpdates)="update('parity')"
        [block]="[keySystem?.parity]"
        [disabled]="otherDisabled"
        [chamberId]="data.structure.chamberTypeId"
        [label]="'Parity'"
      >
        Parity
      </app-kba-input-array>

      <!-- Master Key Combination -->
      <app-kba-input-array
        (inputUpdates)="update('topMasterKey')"
        [block]="[keySystem?.topMasterKey]"
        [disabled]="tmkDisabled"
        [chamberId]="data.structure.chamberTypeId"
        [label]="'TMK'"
      >
        TMK
      </app-kba-input-array>

      <!-- sequenceOfProgression -->
      <app-kba-input-array
        (inputUpdates)="update('sequenceOfProgression')"
        [block]="[keySystem?.sequenceOfProgression]"
        [chamberId]="data.structure.chamberTypeId"
        [label]="'SOP'"
      >
        Sequence Of Progression
      </app-kba-input-array>

      <!-- Ascending/Descending -->
      <app-kba-input-array
        (inputUpdates)="update('keyPatternOrder')"
        [block]="[keySystem?.keyPatternOrder]"
        [chamberId]="data.structure.chamberTypeId"
        [label]="'AscDes'"
      >
        Ascending/Descending
      </app-kba-input-array>

      <!-- Device Chamber -->
      <div padding="12px 6px 0px 12" *ngIf="data?.isRCK" class="row padding all">
        <mat-form-field floatLabel="always" appearance="outline" class="margin right">
            <mat-label
              for="deviceChamber"
              [ngClass]="{
                focus: focus.deviceChamber
              }"
            >
              Device Chamber
            </mat-label>

          <mat-select
            [ngClass]="{
              'focus-border': focus.deviceChamber
            }"
            (focus)="focusOn('constructionKeyType')"
            (focusout)="focusOn('deviceChamber')"
            matNativeControl
            [(ngModel)]="deviceChamber"
            (ngModelChange)="update()"
            required
          >
            <mat-option [value]="2"> 2 </mat-option>
            <mat-option [value]="3"> 3 </mat-option>
            <mat-option [value]="4"> 4 </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Allow Exclusions -->
      <div class="row padding all">
        <mat-checkbox
          id="ignoreTmkGuidelines"
          color="primary"
          [(ngModel)]="ignoreGuidelines"
          (ngModelChange)="update()"
          [checked]="ignoreGuidelines"
        >
          Ignore TMK guidelines
        </mat-checkbox>
      </div>
    </mat-card-content>

  <!-- Buttons -->
  <mat-card-actions>
    <div class="row flex-end">
      <button mat-flat-button [disabled]="canSubmit()" [ngClass]="{'update-tmk-button': !canSubmit()}" class="margin left" id="create" (click)="generate()">
        Update TMK
      </button>
    </div>
  </mat-card-actions>
</mat-card>

